import { render, staticRenderFns } from "./SpireBloodLinkedResultsDataTable.vue?vue&type=template&id=61fbffb6"
import script from "./SpireBloodLinkedResultsDataTable.vue?vue&type=script&lang=js"
export * from "./SpireBloodLinkedResultsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports